import React, { useEffect, useRef, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import '../../../assets/images/codestyle.css';
import useScrollSpy from 'react-use-scrollspy';
import ScrollToTop from '../../Shared/ScrollToTop';
import ApiServer from '../../../assets/images/app-image/environment-setup/api-server.png';
import { ProjectTypeContext } from '../../../ContextHandle'
const ChangeApiServerDetails = ({ setActivePage, sectionRefs, setDocumentation, setDefaultAppActiveMenu }) => {
 /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(506);
        setDocumentation(2);
        setDefaultAppActiveMenu(2);
        document.title = 'Change api server details | ' + projectName;
    }, [setActivePage, setDocumentation, setDefaultAppActiveMenu, projectName]);


    const pagesectionRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const activeSection = useScrollSpy({
        sectionElementRefs: pagesectionRefs,
        offsetPx: -80,
    });


    return (
        <div className='d-flex   justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div id="system-requirements  " className='pt-5 right-content-box-width' >
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">Common Setup</li>
                        <li className="breadcrumb-item active" aria-current="page">Change API server details</li>
                    </ol>
                </nav>

                <h3 className="pt-5 font-weight-bold" >Change API Server</h3>
                <p>
                    <b>Select Project {`>`} lib folder {`>`} services folder {`>`} api-list.dart</b> and replace the API server values with your own web application URL. Example: if your website is <b>https://example.com</b>, set the service URL to <b>https://example.com</b> and the API host/domain to <b>example.com</b>.
                </p>
                <div ref={pagesectionRefs[1]}>
                    <div className='pt-3'>
                        <img src={ApiServer} className="w-100 rounded" alt="Api Server.png "></img>
                    </div>
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/app/push-notification-setup`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Push Notification Setup</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/app/google-maps-settings`} className="text-decoration-none">
                            <a href="/#" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Google Maps Setting</h4>
                        </NavLink>
                    </div>
                </div>
            </div>

        </div>

    );

};

export default ChangeApiServerDetails;
